import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const UserFilters = ({ 
  searchQuery, 
  onSearchChange, 
  selectedDepartment, 
  onDepartmentChange,
  selectedRole,
  onRoleChange,
  selectedStatus,
  onStatusChange,
  onClearFilters,
  resultCount
}) => {
  const departmentOptions = [
    { value: '', label: 'All Departments' },
    { value: 'Engineering', label: 'Engineering' },
    { value: 'Marketing', label: 'Marketing' },
    { value: 'Sales', label: 'Sales' },
    { value: 'HR', label: 'Human Resources' },
    { value: 'Finance', label: 'Finance' },
    { value: 'Operations', label: 'Operations' },
    { value: 'Legal', label: 'Legal' }
  ];

  const roleOptions = [
    { value: '', label: 'All Roles' },
    { value: 'Super Admin', label: 'Super Admin' },
    { value: 'Department Manager', label: 'Department Manager' },
    { value: 'Contributor', label: 'Contributor' },
    { value: 'Viewer', label: 'Viewer' },
    { value: 'Auditor', label: 'Auditor' }
  ];

  const statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'pending', label: 'Pending' },
    { value: 'suspended', label: 'Suspended' }
  ];

  const hasActiveFilters = selectedDepartment || selectedRole || selectedStatus || searchQuery;

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1 max-w-md">
          <Input
            type="search"
            placeholder="Search users by name, email, or department..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3">
          <Select
            placeholder="Department"
            options={departmentOptions}
            value={selectedDepartment}
            onChange={onDepartmentChange}
            className="w-full sm:w-48"
          />
          
          <Select
            placeholder="Role"
            options={roleOptions}
            value={selectedRole}
            onChange={onRoleChange}
            className="w-full sm:w-48"
          />
          
          <Select
            placeholder="Status"
            options={statusOptions}
            value={selectedStatus}
            onChange={onStatusChange}
            className="w-full sm:w-48"
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center space-x-4">
          <span className="text-sm text-muted-foreground">
            {resultCount} user{resultCount !== 1 ? 's' : ''} found
          </span>
          
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
              iconSize={16}
            >
              Clear filters
            </Button>
          )}
        </div>

        <div className="flex items-center space-x-2">
          {selectedDepartment && (
            <div className="flex items-center bg-accent/10 text-accent px-3 py-1 rounded-full text-sm">
              <span>Department: {selectedDepartment}</span>
              <button
                onClick={() => onDepartmentChange('')}
                className="ml-2 hover:text-accent-foreground"
              >
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          
          {selectedRole && (
            <div className="flex items-center bg-primary/10 text-primary px-3 py-1 rounded-full text-sm">
              <span>Role: {selectedRole}</span>
              <button
                onClick={() => onRoleChange('')}
                className="ml-2 hover:text-primary-foreground"
              >
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          
          {selectedStatus && (
            <div className="flex items-center bg-secondary/10 text-secondary px-3 py-1 rounded-full text-sm">
              <span>Status: {selectedStatus}</span>
              <button
                onClick={() => onStatusChange('')}
                className="ml-2 hover:text-secondary-foreground"
              >
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserFilters;